
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.5 6.857a4.773 4.773 0 11-9.545 0 4.773 4.773 0 019.545 0z","fill":"#3092D0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.273 11.546H3.5V6.773a4.773 4.773 0 114.773 4.773z","fill":"url(#paint0_radial_19605_37897)"}}),_c('path',{attrs:{"d":"M16.2 16h1.524l1.292 3.152h.06L20.37 16h1.523v5.09h-1.198v-3.126h-.042l-1.223 3.095h-.766l-1.223-3.113h-.042v3.145H16.2V16zM11.28 21.069H9.963L11.673 16h1.632l1.71 5.069h-1.317l-1.19-3.792h-.04l-1.188 3.792zm-.176-1.995h2.752v.93h-2.752v-.93zM5.5 21.069V16h3.534v.995H6.725v1.04h2.128v.997H6.725v1.042h2.31v.995H5.5zM0 16.995V16h4.284v.995H2.747v4.074H1.54v-4.074H0z","fill":"#4D586A"}}),_c('defs',[_c('radialGradient',{attrs:{"id":"paint0_radial_19605_37897","cx":"0","cy":"0","r":"1","gradientUnits":"userSpaceOnUse","gradientTransform":"rotate(90 .636 7.637) scale(3.57203)"}},[_c('stop',{attrs:{"offset":".359","stop-color":"#FFBD3D"}}),_c('stop',{attrs:{"offset":".745","stop-color":"#FFBB2B"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FFB000"}})])])])
          )
        }
      }
    